
import { useEffect } from 'react';

export default function InstagramFeed() {
  useEffect(() => {
    const d = document;
    const s = d.createElement('script');
    s.type = 'module';
    s.src = 'https://w.behold.so/widget.js';
    d.head.append(s);
    return () => {
      if (d.head.contains(s)) {
        d.head.removeChild(s);
      }
    };
  }, []);

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-400 to-pink-500 text-white text-sm font-semibold px-4 py-2 rounded-full mb-4">
            <i className="fab fa-instagram text-base"></i>
            <span>@brushour_</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <strong>Instagram Feed</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See our latest transformations, colour inspirations, and behind-the-scenes moments straight from Instagram.
          </p>
        </div>

        {/* Behold Widget */}
        <div className="rounded-2xl overflow-hidden">
          {/* @ts-expect-error behold-widget is a custom HTML element not typed in JSX */}
          <behold-widget feed-id="IwMQTnFAsedS1agJPG3C"></behold-widget>
        </div>

        {/* Follow CTA */}
        <div className="text-center mt-10">
          <a
            href="https://www.instagram.com/brushour_"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-orange-500 font-semibold hover:text-pink-500 transition-colors duration-300 cursor-pointer"
          >
            <i className="fab fa-instagram text-xl"></i>
            <span>Follow @brushour_ on Instagram</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
